import { ComponentProps, FC, forwardRef, HTMLAttributes } from 'react';
import s from './OutlinedSelectInput.module.scss';
import { Dropdown } from '@tremor/react';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  defaultValue?: string;
  children: ComponentProps<typeof Dropdown>['children'];
  onChange?: (value: string) => void;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
  testId?: string;
}

export const OutlinedSelectInput: FC<Props> = forwardRef<HTMLDivElement, Props>(
  function OutlinedSelectInput(
    {
      defaultValue,
      className,
      children,
      onChange,
      disabled = false,
      placeholder,
      value,
      testId,
      ...rest
    },
    ref,
  ) {
    return (
      <section className={[className, s.outlinedSelectInput].join(' ')} {...rest}>
        <Dropdown
          data-testid={testId}
          disabled={disabled}
          onValueChange={onChange}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          ref={ref}
        >
          {children}
        </Dropdown>
      </section>
    );
  },
);
